import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CTextareaComponent } from './c-textarea.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CTextareaComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    AsPipesModule,
  ],
  exports: [CTextareaComponent]
})
export class CTextareaModule { }
